module.exports = __webpack_public_path__ + "img/accept.29f86a90.svg";